import PropertyMultiSelectFilterField from 'components/forms/domain/property/PropertyMultiSelectFilterField/PropertyMultiSelectFilterField';
import { useTranslation } from 'react-i18next';
import { APPLIES_TO_FIELD_NAME } from '../SeasonalRuleAddEditModal.constants';

const graphQlFilters = { topLevelOnly: false };

const AppliesToField = () => {
  const { t } = useTranslation();

  return (
    <PropertyMultiSelectFilterField
      label={t('pageProperty.seasonality.modal.fields.appliesTo.title')}
      name={APPLIES_TO_FIELD_NAME}
      graphQlFilters={graphQlFilters}
      enableHotels={false}
      enableUnitTypes
      colSmInput={12}
      colSmLabel={12}
      filtersColXs={12}
      isSelectAllEnabled={false}
    />
  );
};

export default AppliesToField;
